import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const exportToExcel = async (data, fileName, columns) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  // Set headers
  worksheet.columns = columns.map(col => ({
    header: col.label,
    key: col.key,
    width: col.label.length + 10
  }));

  // Header style
  worksheet.getRow(1).eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '4F81BD' }
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });

  // Add rows
  data.forEach(item => worksheet.addRow(item));

  // Save file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, fileName);
};

export default exportToExcel;
